<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">
         <span>动态管理 / 带货商品详情</span>
         <el-button class="back" type="primary" @click="$router.go(-1)">返回</el-button>
      </div>

      <div class="content-wrapper">
         <el-table :data="goodsList" style="overflow-x: auto;">
            <el-table-column prop="name" label="商品名称"></el-table-column>
            <el-table-column inline-template label="商品图片" width="160">
               <img width='100%' :src="row.imgUrl" style="padding-top: 8px;">
            </el-table-column>
            <el-table-column prop="url" label="商品地址" width="360"></el-table-column>
            <el-table-column prop="marketPrice" label="市场价"></el-table-column>
            <el-table-column prop="salesPrice" label="销售价"></el-table-column>
            <el-table-column prop="saleCount" label="销量"></el-table-column>
            <el-table-column prop="status" label="商品状态"></el-table-column>
         </el-table>
      </div>

   </div>
</template>

<script>
import md5 from 'js-md5';
import $ from 'jquery';
import '../../../../assets/lanxi.js'

export default {
   data() {
      return {
         loading: false,
         preGoods: [],
         goodsList: [],
         username: 'ydsj',
         password: 'ns6ag63q',
         goodHost: 'https://m.mall.iydsj.com',
         appSecret: 'APPGHKDBWHdefwefwB4Gdw',
         appId: 'vASH8G3u'
      }
   },

   mounted() {
      let list = this.$util.getStore("goodsList");
      if (list && list != '{}') {
         this.preGoods = JSON.parse(list);
      }
      let type = '', idString = '', goodsId = [];
      if (this.preGoods && this.preGoods.length > 0) {
         this.preGoods.forEach((item, index) => {
            type = item.type + '';
            if (index + 1 == this.preGoods.length) {
               idString += item.id + '';
            } else {
               idString += item.id + ',';
            }
            goodsId.push(item.id);
         })
      }

      if (type == '1') {
         this.getGoodsList(idString);
      } else if (type == '0') {
         this.goodsList = [];
         for (let i = 0; i < goodsId.length; i++) {
            this.getGoodsbyId(goodsId[i])
         }
      }
   },

   methods: {
      getGoodsList(id) {
         let user = JSON.parse(localStorage.getItem('user'));
         let tkey = new Date().getTime() + '';
         let signature = md5(md5(this.password) + tkey + this.username);
         let that = this;

         $.ajax({
            url: that.$util.classHost + '/api/videoInfo',
            type: 'POST',
            contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
            data: {
               username: this.username,
               appuid: user.userId,
               limit: 3,
               ids: id,
               tkey,
               signature
            },
            success: function (res) {
               let result = JSON.parse(res);
               if (result.code == 200) {
                  let url = '', urlType = '/live/';
                  result.data.forEach(element => {
                     if (element.type == 1) {
                        urlType = '/course/'
                     }

                     url = that.$util.classHost + urlType + element.id + '.html'

                     that.goodsList.push({
                        name: element.video_title,
                        marketPrice: element.v_price,
                        salesPrice: element.t_price,
                        imgUrl: element.cover,
                        saleCount: element.video_order_count,
                        url: url,
                        status: element.status == 1 ? '上架' : '下架',
                     })
                  });
               }
            },
            error: function (res) { }
         })
      },

      getGoodsbyId(productId) {
         var that = this;

         var params = $lanxi.getSignParams({
            sortType: 0,
            pageIndex: 1,
            pageSize: 1,
            productId: productId,
            sortOrder: 'desc',
         }, that.appSecret, that.appId);

         $.ajax({
            url: that.goodHost + '/apis/selectProductInfo',
            type: 'POST',
            datatype: "json",
            contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
            data: params,
            success: function (res) {
               if (res.resultCode == 2000 && res.data && res.data.list && res.data.list.length > 0) {
                  let url = '';
                  res.data.list.forEach(element => {
                     var logoImg = element.logoImg.split(';')[0];
                     var isPutSale = '';
                     switch (element.isPutSale + '') {
                        case '1':
                           isPutSale = '未上架';
                           break;
                        case '2':
                           isPutSale = '已上架';
                           break;
                        case '3':
                           isPutSale = '违规下架';
                           break;

                        default:
                           isPutSale = '';
                           break;
                     }
                     that.goodsList.push({
                        imgUrl: logoImg,
                        saleCount: element.totalSales,
                        url: that.goodHost + element.uri,
                        status: isPutSale,
                        name: element.productName,
                        marketPrice: element.marketPrice,
                        salesPrice: element.salesPrice
                     })
                  });
               }
            },
            error: function (res) { }
         })
      },
   }
}
</script>

<style scoped>
.goods-box {
   padding: 0 20px;
}
</style>


// WEBPACK FOOTER //
// GoodsDetail.vue?26810f2c